/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
export default {
  font: {
    mangueira: {
      bold: 'Mangueira Bold',
      medium: 'Mangueira Medium',
    },
  },
  colors: {
    darkYellow: '#F0B01B',

    blueClean: '#00ffff',
    lightBlue: '#106cff',
    mediumBlue: '#2180E8',
    blue: '#000FFF',
    darkBlue: '#074F8C',

    purple: '#0000ff',
    mediumPurple: '#000eff',
    darkPurple: '#11117f',

    black: '#262626',
    gray: '#7A7A7A',
    mediumGray: '#B4B4B4',
    lightGray: '#C1C1C1',

    lightGreen: '#28ff00',
    darkGreen: '#4EC937',
    green: '#00ffff',

    secondaryText: '#808495',
    primaryText: '#575757',

    red: '#C10000',
    white: '#ffffff',
    black2: '#000000',
  },
  gradient: {
    top: 'linear-gradient(180deg, #76fafc,#47b4fc, #1e77fb, #0a59fb, #000FFF)',
    left: 'linear-gradient(90deg, #76fafc, #389efb, #1e77fb, #0a59fb, #000FFF)',
    right:
      'linear-gradient(-90deg, #76fafc, #389efb, #1e77fb, #0a59fb, #000FFF)',
  },
};
